(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["promo-balk-v2"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('pw-promo-bar')) {
    class PWPromoBar extends HTMLElement {
      connectedCallback() {
        if (this.isInitialized) return;

        this.isInitialized = true;
        this.shell = this.closest('.pw-promo-bar-shell');
        this.copyButton = this.querySelector('[data-pw-copy-button]');
        this.copyLabel = this.querySelector('[data-pw-copy-label]');
        this.copyStatus = this.querySelector('[data-pw-copy-status]');
        this.codeValue = this.querySelector('[data-pw-code-value]');
        this.motionToggle = this.querySelector('[data-pw-motion-toggle]');
        this.details = this.querySelector('.pw-promo-bar__details');
        this.detailsSummary = this.details ? this.details.querySelector('summary') : null;
        this.detailsClose = this.querySelector('[data-pw-details-close]');
        this.countdown = this.querySelector('[data-pw-countdown]');
        this.handleCopyClick = this.copyCode.bind(this);
        this.handleMotionClick = this.toggleMotion.bind(this);
        this.handleDetailsClose = () => this.closeDetails(true);
        this.handleDetailsToggle = this.updateDetailsLayer.bind(this);
        this.handleDocumentClick = this.closeDetailsFromOutside.bind(this);
        this.handleDocumentKeydown = this.closeDetailsWithKeyboard.bind(this);
        this.handleFocusOut = this.finishPendingDeactivation.bind(this);
        this.handleVisibilityChange = this.updateDocumentVisibility.bind(this);
        this.handleWindowResize = this.scheduleMarqueeRefresh.bind(this);

        if (this.copyButton) {
          this.copyButton.addEventListener('click', this.handleCopyClick);
        }

        if (this.motionToggle) {
          this.motionToggle.disabled = true;
          this.motionToggle.addEventListener('click', this.handleMotionClick);
        }

        if (this.details) {
          this.details.addEventListener('toggle', this.handleDetailsToggle);

          if (this.detailsClose) {
            this.detailsClose.addEventListener('click', this.handleDetailsClose);
          }

          document.addEventListener('click', this.handleDocumentClick);
          document.addEventListener('keydown', this.handleDocumentKeydown);
          this.updateDetailsLayer();
        }

        document.addEventListener('visibilitychange', this.handleVisibilityChange);
        this.addEventListener('focusout', this.handleFocusOut);
        this.updateDocumentVisibility();
        this.setupSchedule();
        this.setupMarquee();
      }

      disconnectedCallback() {
        if (this.copyButton) {
          this.copyButton.removeEventListener('click', this.handleCopyClick);
        }

        if (this.motionToggle) {
          this.motionToggle.removeEventListener('click', this.handleMotionClick);
        }

        if (this.detailsClose) {
          this.detailsClose.removeEventListener('click', this.handleDetailsClose);
        }

        if (this.details) {
          this.details.removeEventListener('toggle', this.handleDetailsToggle);
        }

        if (this.shell) {
          this.shell.classList.remove('pw-promo-bar-shell--details-open');
        }

        document.removeEventListener('visibilitychange', this.handleVisibilityChange);
        document.removeEventListener('click', this.handleDocumentClick);
        document.removeEventListener('keydown', this.handleDocumentKeydown);
        this.removeEventListener('focusout', this.handleFocusOut);
        window.removeEventListener('resize', this.handleWindowResize);

        if (this.visibilityObserver) {
          this.visibilityObserver.disconnect();
        }

        if (this.resizeObserver) {
          this.resizeObserver.disconnect();
        }

        if (this.reducedMotionQuery && this.handlePresentationChange) {
          if (this.reducedMotionQuery.removeEventListener) {
            this.reducedMotionQuery.removeEventListener('change', this.handlePresentationChange);
          } else {
            this.reducedMotionQuery.removeListener(this.handlePresentationChange);
          }
        }

        if (this.mobileViewportQuery && this.handlePresentationChange) {
          if (this.mobileViewportQuery.removeEventListener) {
            this.mobileViewportQuery.removeEventListener('change', this.handlePresentationChange);
          } else {
            this.mobileViewportQuery.removeListener(this.handlePresentationChange);
          }
        }

        window.clearTimeout(this.scheduleTimer);
        window.clearTimeout(this.copyFeedbackTimer);
        window.clearTimeout(this.copyAnnouncementTimer);
        window.cancelAnimationFrame(this.marqueeFrame);

        if (this.marqueeSource) {
          Array.from(this.marqueeSource.querySelectorAll('[data-pw-fill]')).forEach((node) => node.remove());
        }

        if (this.marqueeClone) {
          this.marqueeClone.replaceChildren();
        }

        this.classList.remove('is-marquee-ready');
        this.isInitialized = false;
      }

      setupSchedule() {
        this.startMilliseconds = Number(this.dataset.startTimestamp) * 1000;
        this.endMilliseconds = Number(this.dataset.endTimestamp) * 1000;
        this.scheduleIsValid = this.dataset.scheduleValid !== 'false';
        this.isDesignMode = this.dataset.designMode === 'true';
        this.showHoursOnly = this.dataset.showHours === 'true';
        this.showSeconds = this.dataset.showSeconds === 'true';

        if (this.countdown && Number.isFinite(this.endMilliseconds) && this.endMilliseconds > 0) {
          this.countdown.dateTime = new Date(this.endMilliseconds).toISOString();
        }

        this.updateSchedule();
        this.scheduleNextUpdate();
      }

      updateSchedule() {
        const now = Date.now();
        const hasStart = Number.isFinite(this.startMilliseconds) && this.startMilliseconds > 0;
        const hasEnd = Number.isFinite(this.endMilliseconds) && this.endMilliseconds > 0;
        const hasStarted = !hasStart || now >= this.startMilliseconds;
        const hasNotEnded = !hasEnd || now < this.endMilliseconds;
        const isActive = this.scheduleIsValid && hasStarted && hasNotEnded;

        if (this.shell && !this.isDesignMode) {
          const wasHidden = this.shell.hidden;

          if (!isActive && this.contains(document.activeElement)) {
            this.pendingDeactivation = true;
          } else {
            this.pendingDeactivation = false;
            this.shell.hidden = !isActive;
          }

          if (isActive && wasHidden) {
            this.scheduleMarqueeRefresh();
          }
        }

        if (!this.countdown || !hasEnd) return;

        const remaining = Math.max(0, this.endMilliseconds - now);
        this.countdown.textContent = this.formatCountdown(remaining);
        this.countdown.setAttribute('aria-label', this.formatAccessibleCountdown(remaining));
      }

      scheduleNextUpdate() {
        window.clearTimeout(this.scheduleTimer);

        const now = Date.now();
        const hasStart = Number.isFinite(this.startMilliseconds) && this.startMilliseconds > 0;
        const hasEnd = Number.isFinite(this.endMilliseconds) && this.endMilliseconds > 0;
        let delay = null;

        if (!this.scheduleIsValid) return;

        if (hasStart && now < this.startMilliseconds && !this.isDesignMode) {
          delay = this.startMilliseconds - now + 50;
        } else if (hasEnd && now < this.endMilliseconds) {
          const remaining = this.endMilliseconds - now;

          if (this.countdown) {
            delay = this.showSeconds
              ? 1000 - (now % 1000) + 25
              : Math.max(250, (remaining % 60000) + 50);
          } else {
            delay = remaining + 50;
          }
        }

        if (delay === null) return;

        const safeDelay = Math.min(Math.max(delay, 50), 2147483000);
        this.scheduleTimer = window.setTimeout(() => {
          this.updateSchedule();
          this.scheduleNextUpdate();
        }, safeDelay);
      }

      finishPendingDeactivation() {
        if (!this.pendingDeactivation || !this.shell) return;

        window.requestAnimationFrame(() => {
          if (this.pendingDeactivation && !this.contains(document.activeElement)) {
            this.pendingDeactivation = false;
            this.shell.hidden = true;
          }
        });
      }

      formatCountdown(milliseconds) {
        const totalSeconds = Math.max(0, Math.floor(milliseconds / 1000));
        const days = Math.floor(totalSeconds / 86400);
        const totalHours = Math.floor(totalSeconds / 3600);
        const hours = Math.floor((totalSeconds % 86400) / 3600);
        const minutes = Math.floor((totalSeconds % 3600) / 60);
        const seconds = totalSeconds % 60;
        const pad = (value) => String(value).padStart(2, '0');

        if (this.showHoursOnly) {
          if (this.showSeconds) {
            return `${pad(totalHours)}:${pad(minutes)}:${pad(seconds)}`;
          }

          return `${totalHours}u ${pad(minutes)}m`;
        }

        if (this.showSeconds) {
          const dayPrefix = days > 0 ? `${days}d ` : '';
          return `${dayPrefix}${pad(hours)}:${pad(minutes)}:${pad(seconds)}`;
        }

        const dayPrefix = days > 0 ? `${days}d ` : '';
        return `${dayPrefix}${pad(hours)}u ${pad(minutes)}m`;
      }

      formatAccessibleCountdown(milliseconds) {
        const totalMinutes = Math.max(0, Math.floor(milliseconds / 60000));
        const days = Math.floor(totalMinutes / 1440);
        const totalHours = Math.floor(totalMinutes / 60);
        const hours = Math.floor((totalMinutes % 1440) / 60);
        const minutes = totalMinutes % 60;

        if (this.showHoursOnly) {
          return `${totalHours} uur en ${minutes} minuten resterend`;
        }

        const parts = [];

        if (days > 0) parts.push(`${days} dagen`);
        if (hours > 0) parts.push(`${hours} uur`);
        parts.push(`${minutes} minuten`);
        return `${parts.join(', ')} resterend`;
      }

      setupMarquee() {
        if (this.dataset.marqueeEnabled !== 'true') return;

        this.marqueeViewport = this.querySelector('[data-pw-marquee-viewport]');
        this.marqueeTrack = this.querySelector('[data-pw-marquee-track]');
        this.marqueeSource = this.querySelector('[data-pw-marquee-source]');
        this.marqueeClone = this.querySelector('[data-pw-marquee-clone]');

        if (!this.marqueeViewport || !this.marqueeTrack || !this.marqueeSource || !this.marqueeClone) return;

        Array.from(this.marqueeSource.querySelectorAll('[data-pw-fill]')).forEach((node) => node.remove());
        this.originalMessages = Array.from(this.marqueeSource.children).filter(
          (message) => !message.hasAttribute('data-pw-fill')
        );
        this.scrollSpeed = Math.max(5, Number(this.dataset.scrollSpeed) || 20);
        this.reducedMotionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.mobileViewportQuery = window.matchMedia('(max-width: 749px)');
        this.handlePresentationChange = this.scheduleMarqueeRefresh.bind(this);

        if (!this.originalMessages.length) return;

        [this.reducedMotionQuery, this.mobileViewportQuery].forEach((query) => {
          if (query.addEventListener) {
            query.addEventListener('change', this.handlePresentationChange);
          } else {
            query.addListener(this.handlePresentationChange);
          }
        });

        this.scheduleMarqueeRefresh();

        if ('ResizeObserver' in window) {
          this.resizeObserver = new ResizeObserver(() => this.scheduleMarqueeRefresh());
          this.resizeObserver.observe(this.marqueeViewport);
        } else {
          window.addEventListener('resize', this.handleWindowResize);
        }

        if ('IntersectionObserver' in window) {
          this.visibilityObserver = new IntersectionObserver(
            (entries) => {
              entries.forEach((entry) => {
                this.classList.toggle('is-in-view', entry.isIntersecting);
              });
            },
            { rootMargin: '100px 0px' }
          );
          this.visibilityObserver.observe(this);
        } else {
          this.classList.add('is-in-view');
        }

        if (document.fonts && document.fonts.ready) {
          document.fonts.ready.then(() => {
            if (this.isConnected) this.scheduleMarqueeRefresh();
          });
        }
      }

      scheduleMarqueeRefresh() {
        window.cancelAnimationFrame(this.marqueeFrame);
        this.marqueeFrame = window.requestAnimationFrame(() => this.refreshMarquee());
      }

      refreshMarquee() {
        if (!this.marqueeViewport || !this.marqueeSource || !this.marqueeClone || !this.marqueeTrack) return;

        Array.from(this.marqueeSource.querySelectorAll('[data-pw-fill]')).forEach((node) => node.remove());

        if (this.usesStaticPresentation()) {
          this.marqueeClone.replaceChildren();
          this.classList.remove('is-marquee-ready');

          if (this.motionToggle) {
            this.motionToggle.disabled = true;
          }

          return;
        }

        const viewportWidth = this.marqueeViewport.clientWidth;

        if (viewportWidth <= 0) {
          this.marqueeClone.replaceChildren();
          this.classList.remove('is-marquee-ready');

          if (this.motionToggle) {
            this.motionToggle.disabled = true;
          }

          return;
        }

        const targetWidth = viewportWidth + 48;
        const maximumSourceNodes = 160;

        while (
          this.marqueeSource.getBoundingClientRect().width < targetWidth &&
          this.marqueeSource.children.length < maximumSourceNodes
        ) {
          this.originalMessages.forEach((message) => {
            if (this.marqueeSource.children.length >= maximumSourceNodes) return;

            const filler = message.cloneNode(true);
            filler.setAttribute('data-pw-fill', '');
            this.makeCloneInert(filler);
            this.marqueeSource.appendChild(filler);
          });
        }

        const cloneNodes = Array.from(this.marqueeSource.children).map((message) => {
          const clone = message.cloneNode(true);
          this.makeCloneInert(clone);
          return clone;
        });

        this.marqueeClone.replaceChildren(...cloneNodes);
        const sourceWidth = Math.ceil(this.marqueeSource.getBoundingClientRect().width);

        if (sourceWidth <= 0) return;

        this.marqueeTrack.style.setProperty('--pw-marquee-shift', `-${sourceWidth}px`);
        this.marqueeTrack.style.setProperty(
          '--pw-promo-duration',
          `${Math.min(180, Math.max(12, sourceWidth / this.scrollSpeed))}s`
        );
        this.classList.add('is-marquee-ready');

        if (this.motionToggle) {
          this.motionToggle.disabled = false;
        }
      }

      usesStaticPresentation() {
        const prefersReducedMotion = this.reducedMotionQuery && this.reducedMotionQuery.matches;
        const usesStaticMobileLayout =
          this.classList.contains('pw-promo-bar--mobile-static') &&
          this.mobileViewportQuery &&
          this.mobileViewportQuery.matches;

        return prefersReducedMotion || usesStaticMobileLayout;
      }

      makeCloneInert(node) {
        node.setAttribute('aria-hidden', 'true');
        node.removeAttribute('data-shopify-editor-block');
        node.querySelectorAll('[data-shopify-editor-block]').forEach((element) => {
          element.removeAttribute('data-shopify-editor-block');
        });
        node.querySelectorAll('[id]').forEach((element) => element.removeAttribute('id'));
        node.querySelectorAll('a, button, input, select, textarea, [tabindex]').forEach((element) => {
          element.setAttribute('tabindex', '-1');
        });
      }

      updateDocumentVisibility() {
        this.classList.toggle('is-document-hidden', document.visibilityState !== 'visible');
      }

      toggleMotion() {
        if (!this.motionToggle) return;

        const isPaused = this.classList.toggle('is-user-paused');
        const label = isPaused
          ? this.motionToggle.dataset.playLabel
          : this.motionToggle.dataset.pauseLabel;

        this.motionToggle.setAttribute('aria-label', label);
      }

      updateDetailsLayer() {
        if (!this.shell || !this.details) return;

        this.shell.classList.toggle('pw-promo-bar-shell--details-open', this.details.open);
      }

      closeDetails(restoreFocus) {
        if (!this.details || !this.details.open) return;

        this.details.open = false;

        if (restoreFocus && this.detailsSummary) {
          this.detailsSummary.focus();
        }
      }

      closeDetailsFromOutside(event) {
        if (!this.details || !this.details.open || this.details.contains(event.target)) return;

        this.closeDetails(false);
      }

      closeDetailsWithKeyboard(event) {
        if (event.key !== 'Escape' || !this.details || !this.details.open) return;

        event.preventDefault();
        this.closeDetails(true);
      }

      async copyCode() {
        if (!this.copyButton) return;

        const code = this.copyButton.dataset.code;

        if (!code) return;

        try {
          await this.writeToClipboard(code);
          this.showCopyFeedback(true, code);
        } catch (error) {
          this.selectVisibleCode();
          this.showCopyFeedback(false, code);
        }
      }

      async writeToClipboard(code) {
        if (navigator.clipboard && window.isSecureContext) {
          try {
            await navigator.clipboard.writeText(code);
            return;
          } catch (error) {
          }
        }

        const temporaryField = document.createElement('textarea');
        temporaryField.value = code;
        temporaryField.setAttribute('readonly', '');
        temporaryField.setAttribute('tabindex', '-1');
        temporaryField.style.position = 'fixed';
        temporaryField.style.top = '0';
        temporaryField.style.left = '-9999px';
        temporaryField.style.opacity = '0';
        document.body.appendChild(temporaryField);

        let didCopy = false;

        try {
          try {
            temporaryField.focus({ preventScroll: true });
          } catch (error) {
            temporaryField.focus();
          }

          temporaryField.select();
          temporaryField.setSelectionRange(0, temporaryField.value.length);
          didCopy = document.execCommand('copy');
        } finally {
          temporaryField.remove();
          this.copyButton.focus();
        }

        if (!didCopy) {
          throw new Error('Copy command failed');
        }
      }

      selectVisibleCode() {
        if (!this.codeValue || !window.getSelection) return;

        const selection = window.getSelection();
        const range = document.createRange();
        range.selectNodeContents(this.codeValue);
        selection.removeAllRanges();
        selection.addRange(range);
      }

      showCopyFeedback(isSuccess, code) {
        const feedbackText = isSuccess
          ? this.copyButton.dataset.copiedLabel
          : this.copyButton.dataset.errorLabel;

        window.clearTimeout(this.copyFeedbackTimer);
        window.clearTimeout(this.copyAnnouncementTimer);
        this.copyButton.classList.toggle('is-copied', isSuccess);
        this.copyButton.classList.toggle('has-copy-error', !isSuccess);

        if (this.copyLabel) {
          this.copyLabel.textContent = feedbackText;
        }

        if (this.copyStatus) {
          this.copyStatus.textContent = '';
          this.copyAnnouncementTimer = window.setTimeout(() => {
            if (this.copyStatus && this.copyStatus.isConnected) {
              this.copyStatus.textContent = `${feedbackText}: ${code}`;
            }
          }, 20);
        }

        this.copyFeedbackTimer = window.setTimeout(() => this.resetCopyFeedback(), 2200);
      }

      resetCopyFeedback() {
        if (!this.copyButton) return;

        this.copyButton.classList.remove('is-copied', 'has-copy-error');

        if (this.copyLabel) {
          this.copyLabel.textContent = this.copyButton.dataset.copyLabel;
        }

        if (this.copyStatus) {
          this.copyStatus.textContent = '';
        }
      }
    }

    customElements.define('pw-promo-bar', PWPromoBar);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pw-collection-promo"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('pw-collection-promo-v4')) {
    class PWCollectionPromo extends HTMLElement {
      connectedCallback() {
        if (this.isInitialized) return;

        this.isInitialized = true;
        this.wrapper = this.closest('.pw-collection-promo-wrap');
        this.copyButton = this.querySelector('[data-pw-copy-button]');
        this.codeValue = this.querySelector('.pw-collection-promo__code-value');
        this.copyLabel = this.querySelector('[data-pw-copy-label]');
        this.copyStatus = this.querySelector('[data-pw-copy-status]');
        this.handleCopyClick = this.copyCode.bind(this);
        this.handleScheduleFocusOut = this.finishPendingScheduleHide.bind(this);

        if (this.copyButton) {
          this.copyButton.addEventListener('click', this.handleCopyClick);
        }

        this.addEventListener('focusout', this.handleScheduleFocusOut);
        this.setupSchedule();
        this.startVisibilityObserver();
      }

      disconnectedCallback() {
        if (this.copyButton) {
          this.copyButton.removeEventListener('click', this.handleCopyClick);
        }

        this.removeEventListener('focusout', this.handleScheduleFocusOut);

        if (this.visibilityObserver) {
          this.visibilityObserver.disconnect();
        }

        window.clearTimeout(this.feedbackTimer);
        window.clearTimeout(this.announcementTimer);
        window.clearTimeout(this.scheduleTimer);
        this.isInitialized = false;
      }

      setupSchedule() {
        const scheduleStart = this.parseScheduledDateTime(this.dataset.scheduleStart);
        const scheduleEnd = this.parseScheduledDateTime(this.dataset.scheduleEnd);

        this.scheduleStartMilliseconds = scheduleStart.milliseconds;
        this.scheduleEndMilliseconds = scheduleEnd.milliseconds;
        this.scheduleIsValid = scheduleStart.isValid && scheduleEnd.isValid;

        if (
          this.scheduleIsValid &&
          this.scheduleStartMilliseconds > 0 &&
          this.scheduleEndMilliseconds > 0 &&
          this.scheduleEndMilliseconds <= this.scheduleStartMilliseconds
        ) {
          this.scheduleIsValid = false;
        }

        this.updateScheduledVisibility();
        this.scheduleNextBoundary();
      }

      parseScheduledDateTime(rawValue) {
        const value = String(rawValue || '').trim();

        if (!value) {
          return { isValid: true, milliseconds: 0 };
        }

        const amsterdamDateTime = value.match(
          /^(\d{1,2})-(\d{1,2})-(\d{4})\s+(\d{1,2}):(\d{2})$/
        );

        if (amsterdamDateTime) {
          const [, day, month, year, hour, minute] = amsterdamDateTime.map(Number);
          return this.convertAmsterdamDateTime({ year, month, day, hour, minute });
        }

        /* Houd reeds opgeslagen ISO 8601-waarden uit oudere versies werkend. */
        if (/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}(?::\d{2})?(?:Z|[+-]\d{2}:\d{2})$/.test(value)) {
          const legacyMilliseconds = Date.parse(value);

          if (Number.isFinite(legacyMilliseconds)) {
            return { isValid: true, milliseconds: legacyMilliseconds };
          }
        }

        return { isValid: false, milliseconds: 0 };
      }

      convertAmsterdamDateTime({ year, month, day, hour, minute }) {
        const requestedAsUtc = Date.UTC(year, month - 1, day, hour, minute);
        const calendarCheck = new Date(requestedAsUtc);
        const hasValidNumbers =
          year >= 2000 &&
          month >= 1 &&
          month <= 12 &&
          day >= 1 &&
          day <= 31 &&
          hour >= 0 &&
          hour <= 23 &&
          minute >= 0 &&
          minute <= 59;
        const isRealDate =
          calendarCheck.getUTCFullYear() === year &&
          calendarCheck.getUTCMonth() === month - 1 &&
          calendarCheck.getUTCDate() === day &&
          calendarCheck.getUTCHours() === hour &&
          calendarCheck.getUTCMinutes() === minute;

        if (!hasValidNumbers || !isRealDate) {
          return { isValid: false, milliseconds: 0 };
        }

        try {
          if (!this.scheduleDateTimeFormatter) {
            this.scheduleDateTimeFormatter = new Intl.DateTimeFormat('en-GB', {
              timeZone: this.dataset.scheduleTimeZone || 'Europe/Amsterdam',
              year: 'numeric',
              month: '2-digit',
              day: '2-digit',
              hour: '2-digit',
              minute: '2-digit',
              second: '2-digit',
              hourCycle: 'h23'
            });
          }

          let amsterdamMilliseconds = requestedAsUtc;

          for (let attempt = 0; attempt < 4; attempt += 1) {
            const parts = this.getAmsterdamDateTimeParts(amsterdamMilliseconds);
            const representedAsUtc = Date.UTC(
              parts.year,
              parts.month - 1,
              parts.day,
              parts.hour,
              parts.minute,
              parts.second
            );
            const correction = requestedAsUtc - representedAsUtc;

            amsterdamMilliseconds += correction;

            if (correction === 0) break;
          }

          const check = this.getAmsterdamDateTimeParts(amsterdamMilliseconds);
          const matchesRequestedTime =
            check.year === year &&
            check.month === month &&
            check.day === day &&
            check.hour === hour &&
            check.minute === minute;

          if (!matchesRequestedTime) {
            return { isValid: false, milliseconds: 0 };
          }

          return { isValid: true, milliseconds: amsterdamMilliseconds };
        } catch (error) {
          return { isValid: false, milliseconds: 0 };
        }
      }

      getAmsterdamDateTimeParts(milliseconds) {
        const values = {};

        this.scheduleDateTimeFormatter.formatToParts(new Date(milliseconds)).forEach((part) => {
          if (part.type !== 'literal') values[part.type] = Number(part.value);
        });

        return values;
      }

      updateScheduledVisibility() {
        if (!this.wrapper) return;

        const now = Date.now();
        const hasStart = Number.isFinite(this.scheduleStartMilliseconds) && this.scheduleStartMilliseconds > 0;
        const hasEnd = Number.isFinite(this.scheduleEndMilliseconds) && this.scheduleEndMilliseconds > 0;
        const hasStarted = !hasStart || now >= this.scheduleStartMilliseconds;
        const hasNotEnded = !hasEnd || now < this.scheduleEndMilliseconds;
        const isActive = this.scheduleIsValid && hasStarted && hasNotEnded;

        if (!isActive && this.contains(document.activeElement)) {
          this.pendingScheduleHide = true;
          return;
        }

        this.pendingScheduleHide = false;
        this.wrapper.hidden = !isActive;
      }

      scheduleNextBoundary() {
        window.clearTimeout(this.scheduleTimer);

        if (!this.scheduleIsValid) return;

        const now = Date.now();
        let nextBoundary = 0;

        if (this.scheduleStartMilliseconds > now) {
          nextBoundary = this.scheduleStartMilliseconds;
        } else if (this.scheduleEndMilliseconds > now) {
          nextBoundary = this.scheduleEndMilliseconds;
        }

        if (nextBoundary <= 0) return;

        const delay = Math.min(Math.max(nextBoundary - now + 50, 50), 2147483000);
        this.scheduleTimer = window.setTimeout(() => {
          this.updateScheduledVisibility();
          this.scheduleNextBoundary();
        }, delay);
      }

      finishPendingScheduleHide() {
        if (!this.pendingScheduleHide || !this.wrapper) return;

        window.requestAnimationFrame(() => {
          if (!this.isConnected || !this.pendingScheduleHide) return;
          if (this.contains(document.activeElement)) return;

          this.pendingScheduleHide = false;
          this.wrapper.hidden = true;
        });
      }

      startVisibilityObserver() {
        if (!this.classList.contains('pw-collection-promo--border-glow')) return;
        if (!this.classList.contains('pw-collection-promo--glow-animated')) return;

        if (!('IntersectionObserver' in window)) {
          this.classList.add('is-in-view');
          return;
        }

        this.visibilityObserver = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              this.classList.toggle('is-in-view', entry.isIntersecting);
            });
          },
          { rootMargin: '120px 0px' }
        );

        this.visibilityObserver.observe(this);
      }

      async copyCode() {
        const code = this.copyButton.dataset.code;

        if (!code) return;

        try {
          await this.writeToClipboard(code);
          this.showFeedback('success', code);
        } catch (error) {
          this.selectVisibleCode();
          this.showFeedback('error', code);
        }
      }

      selectVisibleCode() {
        if (!this.codeValue || !window.getSelection) return;

        const selection = window.getSelection();
        const range = document.createRange();
        range.selectNodeContents(this.codeValue);
        selection.removeAllRanges();
        selection.addRange(range);
      }

      async writeToClipboard(code) {
        if (navigator.clipboard && window.isSecureContext) {
          try {
            await navigator.clipboard.writeText(code);
            return;
          } catch (error) {
          }
        }

        const temporaryField = document.createElement('textarea');
        temporaryField.value = code;
        temporaryField.setAttribute('readonly', '');
        temporaryField.setAttribute('tabindex', '-1');
        temporaryField.style.position = 'fixed';
        temporaryField.style.top = '0';
        temporaryField.style.left = '-9999px';
        temporaryField.style.opacity = '0';
        document.body.appendChild(temporaryField);

        let didCopy = false;

        try {
          try {
            temporaryField.focus({ preventScroll: true });
          } catch (error) {
            temporaryField.focus();
          }

          temporaryField.select();
          temporaryField.setSelectionRange(0, temporaryField.value.length);
          didCopy = document.execCommand('copy');
        } finally {
          temporaryField.remove();
          this.copyButton.focus();
        }

        if (!didCopy) {
          throw new Error('Copy command failed');
        }
      }

      showFeedback(state, code) {
        const isSuccess = state === 'success';
        const feedbackText = isSuccess
          ? this.copyButton.dataset.copiedLabel
          : this.copyButton.dataset.errorLabel;

        window.clearTimeout(this.feedbackTimer);
        this.copyButton.classList.toggle('is-copied', isSuccess);
        this.copyButton.classList.toggle('has-copy-error', !isSuccess);

        if (this.copyLabel) {
          this.copyLabel.textContent = feedbackText;
        }

        if (this.copyStatus) {
          this.copyStatus.textContent = '';
          window.clearTimeout(this.announcementTimer);
          this.announcementTimer = window.setTimeout(() => {
            if (this.copyStatus && this.copyStatus.isConnected) {
              this.copyStatus.textContent = `${feedbackText}: ${code}`;
            }
          }, 20);
        }

        this.feedbackTimer = window.setTimeout(() => {
          this.resetFeedback();
        }, 2200);
      }

      resetFeedback() {
        if (!this.copyButton) return;

        this.copyButton.classList.remove('is-copied', 'has-copy-error');

        if (this.copyLabel) {
          this.copyLabel.textContent = this.copyButton.dataset.copyLabel;
        }

        if (this.copyStatus) {
          this.copyStatus.textContent = '';
        }
      }
    }

    customElements.define('pw-collection-promo-v4', PWCollectionPromo);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pw-recently-viewed-products"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const elementName = 'pw-recent-history-carousel';

    if (customElements.get(elementName)) return;

    class PwRecentlyViewedProducts extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;

        this.shell = this.querySelector('[data-pw-shell]');
        this.track = this.querySelector('[data-pw-track]');
        this.sentinel = this.querySelector('[data-pw-sentinel]');
        this.navigation = this.querySelector('[data-pw-navigation]');
        this.progress = this.querySelector('[data-pw-progress]');
        this.progressControl = this.querySelector('[data-pw-progress-control]');
        this.progressRail = this.querySelector('[data-pw-progress-rail]');
        this.progressThumb = this.querySelector('[data-pw-progress-thumb]');
        this.previousButton = this.querySelector('[data-pw-previous]');
        this.nextButton = this.querySelector('[data-pw-next]');
        this.currentProduct = this.parseCurrentProduct();
        this.maxProducts = Math.max(1, Number.parseInt(this.dataset.maxProducts || '6', 10));
        this.historyLimit = Math.max(12, this.maxProducts + 2);
        this.ttl = 30 * 24 * 60 * 60 * 1000;
        this.abortController = null;
        this.intersectionObserver = null;
        this.controlFrame = null;
        this.progressPointer = null;
        this.rtlScrollType = null;
        this.loadToken = 0;

        this.onPreviousClick = () => this.scrollByCard(-1);
        this.onNextClick = () => this.scrollByCard(1);
        this.onTrackScroll = () => this.queueControlUpdate();
        this.onResize = () => this.queueControlUpdate();
        this.onProgressPointerDown = (event) => this.handleProgressPointerDown(event);
        this.onProgressPointerMove = (event) => this.handleProgressPointerMove(event);
        this.onProgressPointerUp = (event) => this.handleProgressPointerEnd(event, true);
        this.onProgressPointerCancel = (event) => this.handleProgressPointerEnd(event, false);
        this.onProgressLostCapture = (event) => this.handleProgressLostCapture(event);
        this.onProgressKeyDown = (event) => this.handleProgressKeyDown(event);
        this.onPageShow = (event) => {
          if (event.persisted) this.refresh();
        };

        this.previousButton?.addEventListener('click', this.onPreviousClick);
        this.nextButton?.addEventListener('click', this.onNextClick);
        this.track?.addEventListener('scroll', this.onTrackScroll, { passive: true });
        this.progressControl?.addEventListener('pointerdown', this.onProgressPointerDown);
        this.progressControl?.addEventListener('pointermove', this.onProgressPointerMove);
        this.progressControl?.addEventListener('pointerup', this.onProgressPointerUp);
        this.progressControl?.addEventListener('pointercancel', this.onProgressPointerCancel);
        this.progressControl?.addEventListener('lostpointercapture', this.onProgressLostCapture);
        this.progressControl?.addEventListener('keydown', this.onProgressKeyDown);
        window.addEventListener('resize', this.onResize, { passive: true });
        window.addEventListener('pageshow', this.onPageShow);

        this.refresh();
      }

      disconnectedCallback() {
        this.initialized = false;
        this.stopPendingWork();
        this.previousButton?.removeEventListener('click', this.onPreviousClick);
        this.nextButton?.removeEventListener('click', this.onNextClick);
        this.track?.removeEventListener('scroll', this.onTrackScroll);
        this.progressControl?.removeEventListener('pointerdown', this.onProgressPointerDown);
        this.progressControl?.removeEventListener('pointermove', this.onProgressPointerMove);
        this.progressControl?.removeEventListener('pointerup', this.onProgressPointerUp);
        this.progressControl?.removeEventListener('pointercancel', this.onProgressPointerCancel);
        this.progressControl?.removeEventListener('lostpointercapture', this.onProgressLostCapture);
        this.progressControl?.removeEventListener('keydown', this.onProgressKeyDown);
        window.removeEventListener('resize', this.onResize);
        window.removeEventListener('pageshow', this.onPageShow);
        this.finishProgressPointer();
        if (this.controlFrame) cancelAnimationFrame(this.controlFrame);
      }

      parseCurrentProduct() {
        const node = this.querySelector('[data-pw-current-product]');
        if (!node) return null;

        try {
          return this.normalizeItem(JSON.parse(node.textContent), Date.now());
        } catch (error) {
          return null;
        }
      }

      normalizeItem(item, fallbackTime) {
        if (!item || typeof item !== 'object') return null;

        const id = String(item.id || '').trim();
        const handle = typeof item.handle === 'string' ? item.handle.trim() : '';
        const viewedAt = Number.isFinite(Number(item.viewedAt)) ? Number(item.viewedAt) : fallbackTime;
        const title = typeof item.title === 'string' ? item.title.trim().slice(0, 240) : '';
        const url = typeof item.url === 'string' ? item.url.trim().slice(0, 500) : '';
        const secondaryText = typeof item.secondaryText === 'string'
          ? item.secondaryText.trim().slice(0, 120)
          : '';
        const image = item.image && typeof item.image === 'object' && typeof item.image.src === 'string'
          ? {
              src: item.image.src.trim().slice(0, 1000),
              width: Math.max(1, Number.parseInt(item.image.width || '1', 10)),
              height: Math.max(1, Number.parseInt(item.image.height || '1', 10))
            }
          : null;
        const rawPrice = item.price && typeof item.price === 'object' ? item.price : null;
        const currentText = typeof rawPrice?.currentText === 'string'
          ? rawPrice.currentText.trim().slice(0, 60)
          : '';
        const compareText = typeof rawPrice?.compareText === 'string'
          ? rawPrice.compareText.trim().slice(0, 60)
          : '';
        const price = currentText
          ? {
              currentText,
              compareText,
              isDiscount: rawPrice.isDiscount === true,
              isFrom: rawPrice.isFrom === true,
              available: rawPrice.available !== false
            }
          : null;

        if (!id || !handle) return null;

        return {
          snapshotVersion: item.snapshotVersion === 1 ? 1 : 0,
          id,
          handle,
          viewedAt,
          title,
          url,
          image,
          secondaryText,
          hasSecondaryOverride: item.hasSecondaryOverride === true,
          price
        };
      }

      getStorage() {
        try {
          return this.dataset.storageType === 'session' ? window.sessionStorage : window.localStorage;
        } catch (error) {
          return null;
        }
      }

      readHistory() {
        const storage = this.getStorage();
        if (!storage || !this.dataset.storageKey) return [];

        try {
          const saved = JSON.parse(storage.getItem(this.dataset.storageKey) || '{}');
          const rawItems = Array.isArray(saved.items) ? saved.items : [];
          const cutoff = Date.now() - this.ttl;
          const seen = new Set();

          return rawItems.reduce((items, rawItem) => {
            const item = this.normalizeItem(rawItem, 0);
            if (!item || item.viewedAt < cutoff || seen.has(item.id)) return items;
            seen.add(item.id);
            items.push(item);
            return items;
          }, []).slice(0, this.historyLimit);
        } catch (error) {
          return [];
        }
      }

      writeHistory(items) {
        const storage = this.getStorage();
        if (!storage || !this.dataset.storageKey) return;

        try {
          storage.setItem(this.dataset.storageKey, JSON.stringify({
            updatedAt: Date.now(),
            items: items.slice(0, this.historyLimit)
          }));
        } catch (error) {
        }
      }

      saveCurrentProduct(history) {
        if (!this.currentProduct) return history;

        const current = {
          ...this.currentProduct,
          viewedAt: Date.now()
        };
        const updated = [current, ...history.filter((item) => item.id !== current.id)];
        this.writeHistory(updated);
        return updated;
      }

      refresh() {
        if (!this.shell || !this.track || !this.currentProduct) {
          this.hideSection();
          return;
        }

        this.stopPendingWork();
        this.loadToken += 1;
        this.track.replaceChildren();
        this.track.setAttribute('aria-busy', 'false');
        this.hideSection();

        const history = this.readHistory();
        const previousProducts = history
          .filter((item) => item.id !== this.currentProduct.id)
          .slice(0, this.maxProducts);

        this.saveCurrentProduct(history);

        if (!previousProducts.length) return;

        this.candidates = previousProducts;
        this.observeSection();
      }

      observeSection() {
        if (!('IntersectionObserver' in window)) {
          this.loadCandidates(this.candidates);
          return;
        }

        this.intersectionObserver = new IntersectionObserver((entries) => {
          if (!entries.some((entry) => entry.isIntersecting)) return;
          this.intersectionObserver?.disconnect();
          this.intersectionObserver = null;
          this.loadCandidates(this.candidates);
        }, { rootMargin: '360px 0px' });

        this.intersectionObserver.observe(this.sentinel || this);
      }

      stopPendingWork() {
        this.intersectionObserver?.disconnect();
        this.intersectionObserver = null;
        this.abortController?.abort();
        this.abortController = null;
      }

      storefrontUrl(value) {
        if (!value) return '';

        try {
          const url = new URL(value, window.location.origin);
          if (url.origin !== window.location.origin) return '';
          return `${url.pathname}${url.search}${url.hash}`;
        } catch (error) {
          return '';
        }
      }

      imageUrl(value) {
        if (!value) return '';

        try {
          const url = new URL(value, window.location.origin);
          if (url.protocol !== 'https:' && url.protocol !== 'http:') return '';
          return url.toString();
        } catch (error) {
          return '';
        }
      }

      createCachedCard(product) {
        const productUrl = this.storefrontUrl(product.url);
        if (product.snapshotVersion !== 1 || !product.title || !productUrl) return null;

        const item = document.createElement('li');
        item.className = 'pw-rhg__item';
        item.dataset.pwCachedCard = '';
        item.dataset.productId = product.id;

        const link = document.createElement('a');
        link.className = 'pw-rhg__card';
        link.href = productUrl;

        const media = document.createElement('div');
        media.className = 'pw-rhg__media';
        const imageSource = this.imageUrl(product.image?.src);

        if (imageSource) {
          const image = document.createElement('img');
          image.className = 'pw-rhg__image';
          image.src = imageSource;
          image.alt = '';
          image.loading = 'lazy';
          image.decoding = 'async';
          image.setAttribute('fetchpriority', 'low');
          image.width = product.image.width;
          image.height = product.image.height;
          image.addEventListener('error', () => {
            const placeholder = document.createElement('span');
            placeholder.className = 'pw-rhg__placeholder';
            placeholder.setAttribute('aria-hidden', 'true');
            image.replaceWith(placeholder);
          }, { once: true });
          media.append(image);
        } else {
          const placeholder = document.createElement('span');
          placeholder.className = 'pw-rhg__placeholder';
          placeholder.setAttribute('aria-hidden', 'true');
          media.append(placeholder);
        }

        const content = document.createElement('div');
        content.className = 'pw-rhg__content';

        const title = document.createElement('h3');
        title.className = 'pw-rhg__title';
        title.textContent = product.title;
        content.append(title);

        const secondary = document.createElement('p');
        secondary.className = 'pw-rhg__secondary';
        secondary.dataset.pwLiveSecondary = '';
        secondary.textContent = product.secondaryText;
        secondary.hidden = !product.secondaryText;
        content.append(secondary);

        const priceIsFresh = Date.now() - product.viewedAt <= 24 * 60 * 60 * 1000;

        if (product.price && priceIsFresh) {
          const price = document.createElement('div');
          price.className = 'pw-rhg__price';
          price.dataset.pwLivePrice = '';

          const current = document.createElement('span');
          current.className = product.price.isDiscount
            ? 'pw-rhg__current-price pw-rhg__current-price--discount'
            : 'pw-rhg__current-price';

          if (product.price.isFrom) {
            const fromLabel = document.createElement('span');
            fromLabel.className = 'pw-rhg__from-label';
            fromLabel.dataset.pwFromLabel = '';
            fromLabel.textContent = this.dataset.fromLabel || 'Vanaf';
            current.append(fromLabel);
          }

          current.append(document.createTextNode(product.price.currentText));
          price.append(current);

          if (product.price.compareText) {
            const compare = document.createElement('s');
            compare.className = 'pw-rhg__compare-price';
            compare.textContent = product.price.compareText;
            price.append(compare);
          }

          if (!product.price.available) {
            const soldOut = document.createElement('span');
            soldOut.className = 'pw-rhg__sold-out';
            soldOut.textContent = 'Uitverkocht';
            price.append(soldOut);
          }

          content.append(price);
        }

        link.append(media, content);
        item.append(link);
        this.configureCard(item, product);
        return item;
      }

      createSlot(product) {
        const cachedCard = this.createCachedCard(product);
        if (cachedCard) return cachedCard;

        const slot = document.createElement('li');
        slot.hidden = true;
        slot.dataset.pwEmptySlot = '';
        slot.dataset.productId = product.id;
        return slot;
      }

      async loadCandidates(products) {
        if (!Array.isArray(products) || !products.length) return;

        const token = this.loadToken;
        this.abortController = new AbortController();
        const signal = this.abortController.signal;
        const slots = products.map((product) => this.createSlot(product));
        const hasCachedCards = slots.some((slot) => slot.hasAttribute('data-pw-cached-card'));

        this.track.replaceChildren(...slots);
        this.track.setAttribute('aria-busy', 'false');
        this.shell.hidden = !hasCachedCards;
        if (hasCachedCards) this.queueControlUpdate();

        let cursor = 0;
        const workers = Array.from({ length: Math.min(3, products.length) }, async () => {
          while (cursor < products.length) {
            const index = cursor;
            cursor += 1;
            const product = products[index];

            try {
              const result = await this.fetchCard(product, signal);
              if (signal.aborted || token !== this.loadToken) return;

              if (result.card) {
                this.configureCard(result.card, product);
                slots[index].replaceWith(result.card);
                this.shell.hidden = false;
                this.queueControlUpdate();
              } else if (slots[index].hasAttribute('data-pw-empty-slot')) {
                slots[index].remove();
              }
            } catch (error) {
              if (error.name === 'AbortError') return;
              if (slots[index].hasAttribute('data-pw-empty-slot')) slots[index].remove();
            }
          }
        });

        await Promise.allSettled(workers);
        if (signal.aborted || token !== this.loadToken) return;

        this.track.setAttribute('aria-busy', 'false');
        this.abortController = null;

        if (!this.track.querySelector('[data-pw-live-card], [data-pw-cached-card]')) {
          this.hideSection();
          return;
        }

        this.shell.hidden = false;
        this.queueControlUpdate();
      }

      async fetchCard(product, signal) {
        const url = new URL(window.location.href);
        const root = this.dataset.routesRoot || '/';
        const normalizedRoot = root.endsWith('/') ? root : `${root}/`;

        url.pathname = `${normalizedRoot}products/${encodeURIComponent(product.handle)}`.replace(/\/+/g, '/');
        url.hash = '';
        url.searchParams.delete('variant');
        url.searchParams.delete('selling_plan');
        url.searchParams.delete('quantity');
        url.searchParams.set('section_id', this.dataset.cardSectionId);

        const response = await fetch(url.toString(), {
          headers: { 'X-Requested-With': 'XMLHttpRequest' },
          credentials: 'same-origin',
          signal
        });

        if (!response.ok) {
          return { card: null };
        }

        const html = await response.text();
        const documentFragment = new DOMParser().parseFromString(html, 'text/html');
        const card = documentFragment.querySelector('[data-pw-live-card][data-pw-current-card]');
        const matchesProduct = card && String(card.dataset.productId || '') === String(product.id);

        return {
          card: matchesProduct ? document.importNode(card, true) : null
        };
      }

      configureCard(card, product) {
        const secondary = card.querySelector('[data-pw-live-secondary]');
        const price = card.querySelector('[data-pw-live-price]');
        const fromLabel = card.querySelector('[data-pw-from-label]');

        if (secondary) {
          if (this.dataset.showSecondary !== 'true') {
            secondary.hidden = true;
          } else if (product.hasSecondaryOverride && product.secondaryText) {
            secondary.textContent = product.secondaryText;
            secondary.hidden = false;
          } else {
            secondary.hidden = !secondary.textContent.trim();
          }
        }

        if (price) price.hidden = this.dataset.showPrice !== 'true';
        if (fromLabel) fromLabel.textContent = this.dataset.fromLabel || 'Vanaf';
      }

      hideSection() {
        this.finishProgressPointer();
        if (this.shell) this.shell.hidden = true;
        if (this.navigation) this.navigation.hidden = true;
        if (this.progress) this.progress.hidden = true;
      }

      scrollByCard(direction) {
        const item = this.track?.querySelector('.pw-rhg__item:not([hidden])');
        if (!item) return;

        const gap = Number.parseFloat(getComputedStyle(this.track).columnGap) || 0;
        const target = this.getLogicalScrollPosition() + direction * (item.getBoundingClientRect().width + gap);
        this.setLogicalScrollPosition(target, this.scrollBehavior());
      }

      scrollBehavior() {
        return window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
      }

      isRtl() {
        return this.track && getComputedStyle(this.track).direction === 'rtl';
      }

      getRtlScrollType() {
        if (this.rtlScrollType) return this.rtlScrollType;

        const viewport = document.createElement('div');
        const content = document.createElement('div');
        viewport.dir = 'rtl';
        viewport.style.cssText = 'position:absolute;top:-9999px;width:4px;height:1px;overflow:scroll;visibility:hidden;';
        content.style.width = '8px';
        content.style.height = '1px';
        viewport.append(content);
        (document.body || document.documentElement).append(viewport);

        if (viewport.scrollLeft > 0) {
          this.rtlScrollType = 'default';
        } else {
          viewport.scrollLeft = 1;
          this.rtlScrollType = viewport.scrollLeft === 0 ? 'negative' : 'reverse';
        }

        viewport.remove();
        return this.rtlScrollType;
      }

      getLogicalScrollPosition() {
        if (!this.track) return 0;

        const maxScroll = Math.max(0, this.track.scrollWidth - this.track.clientWidth);
        let position = this.track.scrollLeft;

        if (this.isRtl()) {
          const type = this.getRtlScrollType();
          if (type === 'negative') position = -position;
          if (type === 'default') position = maxScroll - position;
        }

        return Math.min(maxScroll, Math.max(0, position));
      }

      setLogicalScrollPosition(value, behavior = 'auto') {
        if (!this.track) return;

        const maxScroll = Math.max(0, this.track.scrollWidth - this.track.clientWidth);
        const position = Math.min(maxScroll, Math.max(0, value));
        let rawPosition = position;

        if (this.isRtl()) {
          const type = this.getRtlScrollType();
          if (type === 'negative') rawPosition = -position;
          if (type === 'default') rawPosition = maxScroll - position;
        }

        this.track.scrollTo({ left: rawPosition, behavior });
      }

      progressGeometry() {
        if (!this.progressRail || !this.progressThumb) return null;

        const rail = this.progressRail.getBoundingClientRect();
        const thumb = this.progressThumb.getBoundingClientRect();
        const travel = Math.max(0, rail.width - thumb.width);

        return { rail, thumb, travel };
      }

      setScrollFromPointer(clientX, pointerOffset) {
        const geometry = this.progressGeometry();
        if (!geometry || geometry.travel <= 0) return;

        const physicalPosition = Math.min(
          1,
          Math.max(0, (clientX - geometry.rail.left - pointerOffset) / geometry.travel)
        );
        const logicalPosition = this.isRtl() ? 1 - physicalPosition : physicalPosition;
        const maxScroll = Math.max(0, this.track.scrollWidth - this.track.clientWidth);

        this.setLogicalScrollPosition(maxScroll * logicalPosition, 'auto');
        this.queueControlUpdate();
      }

      handleProgressPointerDown(event) {
        if (!event.isPrimary || (event.pointerType === 'mouse' && event.button !== 0)) return;

        const geometry = this.progressGeometry();
        const maxScroll = Math.max(0, this.track.scrollWidth - this.track.clientWidth);
        if (!geometry || maxScroll <= 0) return;

        const onThumb = event.clientX >= geometry.thumb.left && event.clientX <= geometry.thumb.right;
        this.progressPointer = {
          id: event.pointerId,
          startX: event.clientX,
          startY: event.clientY,
          offset: onThumb ? event.clientX - geometry.thumb.left : geometry.thumb.width / 2,
          onThumb,
          dragging: event.pointerType === 'mouse',
          cancelled: false
        };

        this.progressControl.setPointerCapture(event.pointerId);

        if (event.pointerType === 'mouse') {
          this.progressControl.focus({ preventScroll: true });
          this.classList.add('is-progress-dragging');
          if (!onThumb) this.setScrollFromPointer(event.clientX, this.progressPointer.offset);
        }
      }

      handleProgressPointerMove(event) {
        const state = this.progressPointer;
        if (!state || state.id !== event.pointerId || state.cancelled) return;

        if (!state.dragging) {
          const horizontalDistance = Math.abs(event.clientX - state.startX);
          const verticalDistance = Math.abs(event.clientY - state.startY);
          if (horizontalDistance < 6 && verticalDistance < 6) return;

          if (verticalDistance > horizontalDistance) {
            state.cancelled = true;
            return;
          }

          state.dragging = true;
          this.classList.add('is-progress-dragging');
        }

        event.preventDefault();
        this.setScrollFromPointer(event.clientX, state.offset);
      }

      handleProgressPointerEnd(event, allowTap) {
        const state = this.progressPointer;
        if (!state || state.id !== event.pointerId) return;

        const wasDragging = state.dragging;
        if (allowTap && !state.cancelled && !state.dragging && !state.onThumb) {
          this.setScrollFromPointer(event.clientX, state.offset);
        }

        this.finishProgressPointer(event.pointerId);
        if (wasDragging) this.snapToNearestCard();
      }

      handleProgressLostCapture(event) {
        if (this.progressPointer?.id !== event.pointerId) return;
        this.progressPointer = null;
        this.classList.remove('is-progress-dragging');
      }

      finishProgressPointer(pointerId) {
        const activePointerId = pointerId ?? this.progressPointer?.id;
        this.progressPointer = null;
        this.classList.remove('is-progress-dragging');

        if (
          activePointerId !== undefined
          && this.progressControl?.hasPointerCapture?.(activePointerId)
        ) {
          this.progressControl.releasePointerCapture(activePointerId);
        }
      }

      snapToNearestCard() {
        const item = this.track?.querySelector('.pw-rhg__item:not([hidden])');
        if (!item) return;

        const gap = Number.parseFloat(getComputedStyle(this.track).columnGap) || 0;
        const step = item.getBoundingClientRect().width + gap;
        if (step <= 0) return;

        const target = Math.round(this.getLogicalScrollPosition() / step) * step;
        this.setLogicalScrollPosition(target, this.scrollBehavior());
      }

      handleProgressKeyDown(event) {
        if (!this.track) return;

        const item = this.track.querySelector('.pw-rhg__item:not([hidden])');
        const gap = Number.parseFloat(getComputedStyle(this.track).columnGap) || 0;
        const cardStep = item ? item.getBoundingClientRect().width + gap : 40;
        const current = this.getLogicalScrollPosition();
        const maxScroll = Math.max(0, this.track.scrollWidth - this.track.clientWidth);
        let target = null;

        if (event.key === 'ArrowLeft') target = current + (this.isRtl() ? cardStep : -cardStep);
        if (event.key === 'ArrowRight') target = current + (this.isRtl() ? -cardStep : cardStep);
        if (event.key === 'PageUp') target = current - this.track.clientWidth;
        if (event.key === 'PageDown') target = current + this.track.clientWidth;
        if (event.key === 'Home') target = 0;
        if (event.key === 'End') target = maxScroll;
        if (event.key === ' ') target = current + (event.shiftKey ? -this.track.clientWidth : this.track.clientWidth);

        if (target === null) return;
        event.preventDefault();
        this.setLogicalScrollPosition(target, this.scrollBehavior());
      }

      queueControlUpdate() {
        if (this.controlFrame) cancelAnimationFrame(this.controlFrame);
        this.controlFrame = requestAnimationFrame(() => {
          this.controlFrame = null;
          this.updateControls();
        });
      }

      updateControls() {
        if (
          !this.track
          || !this.progress
          || !this.progressControl
          || !this.progressRail
          || !this.progressThumb
        ) return;

        const overflow = this.track.scrollWidth - this.track.clientWidth > 2;
        if (this.navigation) this.navigation.hidden = !overflow;
        this.progress.hidden = !overflow;

        if (!overflow) {
          this.progressThumb.style.width = '100%';
          this.progressThumb.style.transform = 'translate3d(0, 0, 0)';
          this.progressControl.setAttribute('aria-valuenow', '0');
          return;
        }

        const maxScroll = this.track.scrollWidth - this.track.clientWidth;
        const scrollPosition = this.getLogicalScrollPosition();
        const visibleRatio = Math.min(1, this.track.clientWidth / this.track.scrollWidth);
        const railWidth = this.progressRail.getBoundingClientRect().width;
        const thumbWidth = Math.min(railWidth, Math.max(28, railWidth * visibleRatio));
        const travel = Math.max(0, railWidth - thumbWidth);
        const progressPosition = maxScroll > 0 ? scrollPosition / maxScroll : 0;
        const physicalPosition = this.isRtl() ? 1 - progressPosition : progressPosition;
        const percentage = Math.round(progressPosition * 100);

        this.progressThumb.style.width = `${thumbWidth}px`;
        this.progressThumb.style.transform = `translate3d(${physicalPosition * travel}px, 0, 0)`;
        this.progressControl.setAttribute('aria-valuenow', String(percentage));
        if (this.previousButton) this.previousButton.disabled = scrollPosition <= 2;
        if (this.nextButton) this.nextButton.disabled = scrollPosition >= maxScroll - 2;
      }
    }

    customElements.define(elementName, PwRecentlyViewedProducts);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pw-referral-banner"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const banners = document.querySelectorAll('[data-pw-referral-banner][data-motion="true"]');
    if (!banners.length || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    const active = new Set();
    let ticking = false;

    const update = () => {
      ticking = false;
      const viewport = window.innerHeight || 1;

      active.forEach((banner) => {
        const rect = banner.getBoundingClientRect();
        const center = rect.top + rect.height / 2;
        const distance = (center - viewport / 2) / viewport;
        const clamped = Math.max(-1, Math.min(1, distance));
        const toast = 1 - Math.min(1, Math.abs(clamped) * 1.8);
        const rotation = clamped * -1.2;

        banner.style.setProperty('--pw-bg-x', `${clamped * -7}px`);
        banner.style.setProperty('--pw-bg-y', `${toast * -3}px`);
        banner.style.setProperty('--pw-fallback-x', `${clamped * -16}px`);
        banner.style.setProperty('--pw-fallback-y', `${toast * 7}px`);
        banner.style.setProperty('--pw-fallback-rotate', `${rotation * -.35}deg`);
        banner.style.setProperty('--pw-left-glass-x', `${toast * 10 + clamped * -4}px`);
        banner.style.setProperty('--pw-left-glass-y', `${toast * -5}px`);
        banner.style.setProperty('--pw-left-glass-rotate', `${-8 + rotation * -.5}deg`);
        banner.style.setProperty('--pw-left-glass-scale', String(1 + toast * .055));
        banner.style.setProperty('--pw-right-glass-x', `${toast * -10 + clamped * 4}px`);
        banner.style.setProperty('--pw-right-glass-y', `${toast * -5}px`);
        banner.style.setProperty('--pw-right-glass-rotate', `${8 + rotation * .5}deg`);
        banner.style.setProperty('--pw-right-glass-scale', String(1 + toast * .055));
        banner.style.setProperty('--pw-card-x', `${clamped * 8}px`);
        banner.style.setProperty('--pw-card-y', `${toast * -5}px`);
        banner.style.setProperty('--pw-card-rotate', `${-2 + rotation}deg`);
        banner.style.setProperty('--pw-ribbon-x', `${clamped * 10}px`);
        banner.style.setProperty('--pw-ribbon-y', `${toast * -6}px`);
        banner.style.setProperty('--pw-ribbon-rotate', `${18 + rotation}deg`);
      });
    };

    const requestUpdate = () => {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(update);
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          active.add(entry.target);
        } else {
          active.delete(entry.target);
        }
      });
      requestUpdate();
    }, { rootMargin: '120px 0px' });

    banners.forEach((banner) => observer.observe(banner));
    window.addEventListener('scroll', requestUpdate, { passive: true });
    window.addEventListener('resize', requestUpdate);
    requestUpdate();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pw-wine-directory"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const validStyles = ['all', 'rood', 'wit', 'rose', 'mousserend', 'dessert', 'alcoholvrij'];

    function initDirectory(root) {
      if (root.dataset.pwReady === 'true') return;

      const queryKey = root.dataset.queryKey || 'soort';
      const params = new URLSearchParams(window.location.search);
      let style = params.get(queryKey) || root.dataset.initialStyle || 'all';
      if (!validStyles.includes(style)) style = 'all';

      const searchInput = root.querySelector('.pw-wd__search-input');
      const tabs = [...root.querySelectorAll('[data-style]')];
      const empty = root.querySelector('.pw-wd__empty');
      const status = root.querySelector('.pw-wd__status');
      let searchTerm = '';

      function readSetting(selector) {
        const element = root.querySelector(selector);
        if (!element) return '';
        try {
          return JSON.parse(element.textContent) || '';
        } catch (error) {
          return '';
        }
      }

      function lines(value) {
        return value.split(/\r?\n/).map((line) => line.trim()).filter(Boolean);
      }

      const styleMap = {};
      lines(readSetting('[data-pw-style-map]')).forEach((line) => {
        const [key, collectionHandle, filterValue, label] = line.split('|').map((part) => part.trim());
        if (key && collectionHandle) styleMap[key] = { collectionHandle, filterValue, label };
      });

      if (!styleMap.alcoholvrij) {
        styleMap.alcoholvrij = { collectionHandle: 'alcoholvrije-wijn', filterValue: '', label: 'Alcoholvrij' };
      }

      const verifiedStyleFilterValues = {
        rood: 'gid://shopify/FilterSettingGroup/74711119',
        wit: 'gid://shopify/FilterSettingGroup/74743887',
        rose: 'gid://shopify/FilterSettingGroup/74776655',
        mousserend: 'gid://shopify/FilterSettingGroup/74809423',
        dessert: 'gid://shopify/FilterSettingGroup/74907727'
      };

      Object.entries(verifiedStyleFilterValues).forEach(([key, filterValue]) => {
        if (styleMap[key] && !styleMap[key].filterValue) styleMap[key].filterValue = filterValue;
      });

      const parameterMap = {};
      lines(readSetting('[data-pw-parameter-map]')).forEach((line) => {
        const [key, parameter] = line.split('|').map((part) => part.trim());
        if (key && parameter) parameterMap[key] = parameter;
      });

      const filterOverrides = {};
      lines(readSetting('[data-pw-filter-overrides]')).forEach((line) => {
        const [scope, label, value] = line.split('|').map((part) => part.trim());
        if (scope && label && value) filterOverrides[`${scope}|${label.toLocaleLowerCase('nl')}`] = value;
      });

      function nativeFilterValue(scope, value) {
        if (!value) return '';
        return filterOverrides[`${scope}|${value.trim().toLocaleLowerCase('nl')}`] || value.trim();
      }

      function countFor(element) {
        return Number(element.dataset[`count${style.charAt(0).toUpperCase()}${style.slice(1)}`] || 0);
      }

      function updateLink(link) {
        if (style === 'all' || !styleMap[style]) {
          link.href = link.dataset.baseUrl;
          return;
        }

        const styleConfig = styleMap[style];
        const url = new URL(`${root.dataset.collectionsUrl}/${styleConfig.collectionHandle}`, window.location.origin);

        if (style !== 'alcoholvrij' && styleConfig.filterValue && parameterMap.soort) {
          url.searchParams.set(parameterMap.soort, styleConfig.filterValue);
        }
        if (link.dataset.filterLand && parameterMap.land) {
          url.searchParams.set(parameterMap.land, nativeFilterValue('land', link.dataset.filterLand));
        }
        if (link.dataset.filterRegion && parameterMap.regio) {
          url.searchParams.set(parameterMap.regio, nativeFilterValue('regio', link.dataset.filterRegion));
        }
        if (link.dataset.filterGrape && parameterMap.druif) {
          url.searchParams.set(parameterMap.druif, nativeFilterValue('druif', link.dataset.filterGrape));
        }
        if (root.dataset.sortBy) url.searchParams.set('sort_by', root.dataset.sortBy);

        link.href = `${url.pathname}${url.search}`;
      }

      function matchesText(element, inheritedMatch = false) {
        if (!searchTerm) return true;
        return inheritedMatch || (element.dataset.search || '').includes(searchTerm);
      }

      function applyFilters() {
        let visibleCount = 0;

        if (root.dataset.mode === 'countries') {
          root.querySelectorAll('.pw-wd__country').forEach((country) => {
            const countryStyleMatch = countFor(country) > 0;
            const countryTextMatch = matchesText(country);
            let visibleRegions = 0;

            country.querySelectorAll('.pw-wd__region').forEach((region) => {
              const showRegion = countFor(region) > 0 && matchesText(region, countryTextMatch);
              region.hidden = !showRegion;
              if (showRegion) visibleRegions += 1;
            });

            const showCountry = countryStyleMatch && (countryTextMatch || visibleRegions > 0 || !searchTerm);
            country.hidden = !showCountry;
            if (showCountry) visibleCount += 1;
          });

          if (root.dataset.openFirst === 'true') {
            const visibleCountries = [...root.querySelectorAll('.pw-wd__country:not([hidden])')];
            if (visibleCountries.length && !visibleCountries.some((country) => country.open)) visibleCountries[0].open = true;
          }
        } else {
          root.querySelectorAll('.pw-wd__grape').forEach((grape) => {
            const showGrape = countFor(grape) > 0 && matchesText(grape);
            grape.hidden = !showGrape;
            if (showGrape) visibleCount += 1;
          });

          root.querySelectorAll('.pw-wd__grape-group').forEach((group) => {
            const hasVisibleGrape = [...group.querySelectorAll('.pw-wd__grape')].some((grape) => !grape.hidden);
            group.hidden = !hasVisibleGrape;
            const letterLink = root.querySelector(`[data-letter-link="${CSS.escape(group.dataset.letter)}"]`);
            if (letterLink) letterLink.hidden = !hasVisibleGrape;
          });
        }

        root.querySelectorAll('[data-count-output]').forEach((output) => {
          const item = output.closest('[data-count-all]');
          if (item) output.textContent = countFor(item);
        });

        root.querySelectorAll('.pw-wd__collection-link').forEach(updateLink);
        tabs.forEach((tab) => tab.setAttribute('aria-current', String(tab.dataset.style === style)));
        if (empty) empty.hidden = visibleCount > 0;
        if (status) {
          const label = root.dataset.mode === 'countries' ? root.dataset.statusCountries : root.dataset.statusGrapes;
          status.textContent = `${visibleCount} ${label}`;
        }
      }

      tabs.forEach((tab) => {
        tab.addEventListener('click', (event) => {
          event.preventDefault();
          style = tab.dataset.style;
          const url = new URL(window.location.href);
          if (style === 'all') url.searchParams.delete(queryKey);
          else url.searchParams.set(queryKey, style);
          window.history.replaceState({}, '', url);
          applyFilters();
        });
      });

      if (searchInput) {
        searchInput.addEventListener('input', () => {
          searchTerm = searchInput.value.trim().toLocaleLowerCase('nl');
          applyFilters();
        });
      }

      root.dataset.pwReady = 'true';
      applyFilters();
    }

    function initAll(scope = document) {
      scope.querySelectorAll('.pw-wd').forEach(initDirectory);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initAll(), { once: true });
    } else {
      initAll();
    }
    document.addEventListener('shopify:section:load', (event) => initAll(event.target));
  })();

  } catch(e) { console.error(e); }
})();
})();
